import script from "./IntroPage.vue?vue&type=script&setup=true&lang=js"
export * from "./IntroPage.vue?vue&type=script&setup=true&lang=js"

import "./IntroPage.vue?vue&type=style&index=0&id=7bc68e31&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bc68e31"]])

export default __exports__